import { CTACard } from "@/components/shared/CTACard";

export const CTACardPreviewResults = () => (
  <CTACard
    heading={
      <>
        <span>Free yourself up</span> from research <br />
        and writing!
      </>
    }
    subheading="Hire an expert to write you a 100% unique paper aligned to your needs."
    btnText="Contact a pro"
  />
);
